export default __webpack_public_path__ + "static/media/mode-option-single.e83a01b2.png";